
<div class="row mt-16">
    <div class="col-auto ml-auto">
      <div class="dropdown mr-16 display-inline-flex" *ngIf="summaryType == SummaryType.Daily">
        <input type="date" [(ngModel)]="startDateValue" (change)="onChangeStartDate()">
      </div>
      <div class="dropdown mr-16 display-inline-flex" *ngIf="summaryType == SummaryType.Daily">
        <input type="date" [(ngModel)]="endDateValue" (change)="onChangeEndDate()">
      </div>
      <div class="dropdown mr-16 display-inline-flex" *ngIf="summaryType != SummaryType.Daily">
        <button class="btn-1 btn-dropdown" type="button" id="yearlyDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span>{{selectedFilter}}</span>
          <img src="../../../assets/images/caret-icon.svg" alt="caret-icon" width="16px" height="16px" >
        </button>
        <div class="dropdown-menu" aria-labelledby="yearlyDropdown" style="z-index: 9999999;">
          <ng-container *ngFor="let item of dateFilterList">
              <button class="dropdown-item" (click)="onChangeFilter(item.startDate,item.endDate,item.startMonth,item.endMonth,item.year);
              selectedFilter = item.label;">{{item.label}}</button>
          </ng-container>
        </div>
      </div>  
      <div class="dropdown mr-16 display-inline-flex" *ngIf="summaryType != SummaryType.Daily && summaryType != SummaryType.Yearly">
        <button class="btn-1 btn-dropdown" type="button" id="yearlyDropdown2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span>{{selectedYear}}</span>
          <img src="../../../assets/images/caret-icon.svg" alt="caret-icon" width="16px" height="16px" >
        </button>
        <div class="dropdown-menu" aria-labelledby="yearlyDropdown2" style="z-index: 9999999;">
          <ng-container *ngFor="let year of yearFilterList">
              <button class="dropdown-item" (click)="onChangeYear(year)">{{year}}</button>
          </ng-container>
        </div>
      </div>  
        <div class="dropdown display-inline-flex">
          <button class="btn-1 btn-dropdown" type="button" id="periodDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span>{{summaryType}}</span>
            <img src="../../../assets/images/caret-icon.svg" alt="caret-icon" width="16px" height="16px" >
          </button>
          <div class="dropdown-menu" aria-labelledby="periodDropdown" style="z-index: 9999999;">
            <button class="dropdown-item" (click)="onSelectSummaryType(SummaryType.Yearly)">{{SummaryType.Yearly}}</button>
            <button class="dropdown-item" (click)="onSelectSummaryType(SummaryType.HalfYearly)">{{SummaryType.HalfYearly}}</button>
            <button class="dropdown-item" (click)="onSelectSummaryType(SummaryType.Quarterly)">{{SummaryType.Quarterly}}</button>
            <button class="dropdown-item" (click)="onSelectSummaryType(SummaryType.Monthly)">{{SummaryType.Monthly}}</button>
            <button class="dropdown-item" (click)="onSelectSummaryType(SummaryType.Daily)">{{SummaryType.Daily}}</button>
          </div>
        </div>  
    </div>
  </div>